import { Button, Typography, Badge } from "@altimateai/lego";
import { Stack } from "@altimateai/lego";
import { TestCase } from "../../services/evals";

interface TagsFilterProps {
  allTags: string[];
  selectedTags: string[];
  testCases: TestCase[] | undefined;
  onToggleTag: (tag: string) => void;
  setSelectedTags: (tags: string[]) => void;
  onSelectAll: () => void;
  onDeselectAll: () => void;
}

export const TagsFilter: React.FC<TagsFilterProps> = ({
  allTags,
  selectedTags,
  testCases,
  onToggleTag,
  setSelectedTags,
  onSelectAll,
  onDeselectAll,
}) => {
  if (allTags.length === 0) {
    return null;
  }

  return (
    <div className="al-mb-4 al-w-full">
      <Stack
        direction="row"
        justify="between"
        align="center"
        className="al-mb-2 al-flex-wrap al-gap-2"
      >
        <Typography size="sm" weight="medium">
          Filter by Tags
        </Typography>
        <Stack direction="row" gap="sm">
          <Button onClick={onSelectAll} size="sm" variant="outline">
            Select All
          </Button>
          <Button onClick={onDeselectAll} size="sm" variant="outline">
            Deselect All
          </Button>
        </Stack>
      </Stack>
      <div className="al-w-full">
        {allTags.map(tag => {
          const count = (Array.isArray(testCases) ? testCases : []).filter(tc =>
            tc.tags?.includes(tag)
          ).length;
          const isSelected = selectedTags.includes(tag);
          return (
            <Badge
              key={tag}
              className={`al-inline-block al-mr-2 al-mb-2 al-cursor-pointer al-whitespace-nowrap ${
                isSelected
                  ? "!al-bg-cyan-600 !al-text-white hover:!al-bg-cyan-700 al-border al-border-cyan-600"
                  : "!al-bg-cyan-100 !al-text-cyan-700 al-border al-border-cyan-200 hover:!al-bg-cyan-200"
              }`}
              onClick={() => onToggleTag(tag)}
            >
              {tag} ({count})
            </Badge>
          );
        })}
        {selectedTags.length > 0 && (
          <Button
            onClick={() => setSelectedTags([])}
            size="sm"
            variant="ghost"
            className="al-inline-block al-mr-2 al-mb-2 al-text-xs al-h-6 al-whitespace-nowrap"
          >
            Clear Tags
          </Button>
        )}
      </div>
    </div>
  );
};
